// 邀请人数导出字段选择弹窗
import Vue from 'vue';
import useCustomMessageBox from './useCustomMessageBox.js';

const DEFAULT_EXPORT_FIELDS = [
  'nickname',
  'joinId',
  'num',
  'watchDuration',
  'liveWatchDuration',
  'vodWatchDuration',
  'client',
  'location',
  'inviteType',
  'enterTime',
  'channelName'
];

const MessageBoxConent = Vue.extend({
  props: {
    // 打开弹窗时的时间戳,用于监听变化
    openTs: Number
  },
  watch: {
    openTs: {
      handler(newVal) {
        if (newVal) {
          this.formData.export_fields = getExportFields();
        }
      },
      immediate: true
    }
  },
  data() {
    const validateFields = (rule, value, callback) => {
      if (!value || value.length === 0) {
        callback(new Error('请至少选择一个要导出的字段'));
      } else {
        callback();
      }
    };
    return {
      formData: {
        // 导出字段
        export_fields: DEFAULT_EXPORT_FIELDS
        // nickname: true, // 原用户名(实际是昵称)
        // nicknameUpdated: false, // 修改后的用户名(实际是昵称)
        // wechatOpenId: false, // 微信OpenID
        // joinId: true, // 参会ID
        // num: true, // 邀请人数
        // phone: false, // 手机号
        // email: false, // 邮箱
        // jobNumber: false, // 工号
        // watchDuration: true, // 观看时长
        // liveWatchDuration: true, // 直播观看时长
        // vodWatchDuration: true, // 回放观看时长
        // client: true, // 观看终端
        // location: true, // 地理位置
        // inviteType: true, // 邀请方式
        // enterTime: true, // 进入时间
        // channelName: true // 渠道来源
      },
      rules: {
        export_fields: [
          { validator: validateFields, trigger: 'change' } // 自定义其它验证, 20250526这里注释掉改由服务端校验
        ]
      }
    };
  },
  // 使用es6-string-html定义模板
  template: /*html*/ `
     <div class="message-content">
        <p class="message-tip">提示：导出字段的设置，仅针对邀请此页面数据导出的设置</p>
        <vh-form :model="formData" :rules="rules" label-width="70px" class="message-content-form">
          <vh-form-item label="导出字段" prop="export_fields" style="margin-bottom:0;">
            <vh-checkbox-group v-model="formData.export_fields">
              <vh-checkbox label="nickname" name="export_fields">原用户名</vh-checkbox>
              <vh-checkbox label="nicknameUpdated" name="export_fields">修改后的用户名</vh-checkbox>
              <vh-checkbox label="wechatOpenId" name="export_fields">微信OpenID</vh-checkbox>
              <vh-checkbox label="joinId" name="export_fields">参会ID</vh-checkbox>
              <vh-checkbox label="num" name="export_fields">邀请人数</vh-checkbox>
              <vh-checkbox label="phone" name="export_fields">手机号</vh-checkbox>
              <vh-checkbox label="email" name="export_fields">邮箱</vh-checkbox>
              <vh-checkbox label="jobNumber" name="export_fields">工号</vh-checkbox>
              <vh-checkbox label="watchDuration" name="export_fields">观看时长</vh-checkbox>
              <vh-checkbox label="liveWatchDuration" name="export_fields">直播观看时长</vh-checkbox>
              <vh-checkbox label="vodWatchDuration" name="export_fields">回放观看时长</vh-checkbox>
              <vh-checkbox label="client" name="export_fields">观看终端</vh-checkbox>
              <vh-checkbox label="location" name="export_fields">地理位置</vh-checkbox>
              <vh-checkbox label="inviteType" name="export_fields">邀请方式</vh-checkbox>
              <vh-checkbox label="enterTime" name="export_fields">进入时间</vh-checkbox>
              <vh-checkbox label="channelName" name="export_fields">渠道来源</vh-checkbox>
            </vh-checkbox-group>
          </vh-form-item>
        </vh-form>
      </div>
  `
});

function getExportFields() {
  const cacheExportFieldsStr = localStorage.getItem('invite_rank_export_fields');
  if (cacheExportFieldsStr) {
    const cacheExportFields = cacheExportFieldsStr.split(',');
    return cacheExportFields.length > 0 ? cacheExportFields : DEFAULT_EXPORT_FIELDS;
  } else {
    return DEFAULT_EXPORT_FIELDS;
  }
}

function setExportFieldsToCache(export_fields) {
  if (Array.isArray(export_fields)) {
    localStorage.setItem('invite_rank_export_fields', export_fields.join(','));
  } else {
    localStorage.setItem('invite_rank_export_fields', export_fields);
  }
}

export default async function useInviteRankChoice(h, options) {
  if (!options) options = {};
  options.confirmHook = function (formData) {
    setExportFieldsToCache(formData.export_fields);
  };
  options.cancelHook = function (formData) {
    setExportFieldsToCache(formData.export_fields);
  };
  return useCustomMessageBox(h, MessageBoxConent, options);
}
